<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <b-navbar :no-body="true" class="p-0 ml-auto" fixed :sticky="true" toggleable="lg" type="light" :variant="isDark ? 'dark' : 'light'">
        <b-navbar-brand>
            <i class="fa fa-user bg-info p-3 font-2xl mr-3 float-left "></i>
            <div class="h5 text-primary mb-0 mt-2" style="padding-right: 150px !important;">
              Usuário - Cadastro / Edição
            </div>
            <div class="text-uppercase font-weight-bold font-xs" :class="isDark ? 'text-light' : 'text-muted'">
              {{registro.ID}} - {{registro.NOME_COMPLETO || registro.CPF}}
            </div>
        </b-navbar-brand>
        
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="lg" variant="outline-info" class="px-3 font-weight-bold" type="button" @click="$router.go(-1)" > 
                   <i class="fa fa-arrow-left"></i>  Voltar
              </b-button>
              <b-button  size="lg" class="px-4 font-weight-bold" variant="success" type="button" @click="post()" :disabled="processando"> 
                  <i class="fa fa-save"></i>  Gravar
              </b-button> 
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

        <b-row>
          <div class="col-sm-12">
            <b-card :bg-variant="isDark ? 'gray-700' : 'gray-100'">
              <div slot="header">
                <i class='fa fa-align-justify'></i><strong> Dados do Usuário</strong>
              </div>
              <b-row>
                  <!--/.col-->
                  <b-col sm="2">
                    <b-form-fieldset label="Código">
                      <b-form-input type="text" id="ID" :disabled="true" placeholder="Automático" v-model="registro.ID"></b-form-input>
                    </b-form-fieldset>
                  </b-col>
                  
                   <!--/.col-->
                  <b-col sm="4">
                    <b-form-fieldset label="Login / CPF *">
                      <b-form-input class="form-control" id="inputCPF" 
                      placeholder="Login ou CPF" 
                      v-model="registro.CPF"
                      :disabled="desabilitado"
                      ></b-form-input>
                    </b-form-fieldset>
                  </b-col>
                  
                   <!--/.col-->
                  <b-col sm="6">
                    <b-form-fieldset label="Nome Completo *">
                      <b-form-input type="text" id="nomeCompleto" 
                      placeholder="Nome completo do usuário" 
                      v-model="registro.NOME_COMPLETO"
                      :disabled="desabilitado"
                      ></b-form-input>
                    </b-form-fieldset>
                  </b-col>
              </b-row>
              
              <b-row>
                   <!--/.col-->
                  <b-col sm="4">
                    <b-form-fieldset label="Email">
                      <b-form-input type="email" id="email" 
                      placeholder="Email (opcional)" 
                      v-model="registro.EMAIL"
                      :disabled="desabilitado"
                      ></b-form-input>
                    </b-form-fieldset>
                  </b-col>
                  
                  <!--/.col-->
                  <b-col sm="4" v-if="!registro.ID">
                    <b-form-fieldset label="Senha *">
                      <b-form-input type="password" id="senha" 
                      placeholder="Senha para acesso" 
                      v-model="registro.SENHA"
                      :disabled="desabilitado"
                      ></b-form-input>
                    </b-form-fieldset>
                  </b-col>
                  
                  <!--/.col-->
                  <b-col sm="4" v-if="!registro.ID">
                    <b-form-fieldset label="Confirmar Senha *">
                      <b-form-input type="password" id="senhaConfirma" 
                      placeholder="Digite a senha novamente" 
                      v-model="registro.SENHA_CONFIRMA"
                      :disabled="desabilitado"
                      ></b-form-input>
                    </b-form-fieldset>
                  </b-col>
              </b-row>
              
              <b-row>
                 <b-col sm="4">
                    <b-form-fieldset label="Grupo de Acesso *">
                        <GrupoAcessoDropDown v-model="registro.GRUPO_ACESSO_ID" :disabled="desabilitado" />
                    </b-form-fieldset>
                 </b-col>
                 <b-col sm="4">
                    <b-form-fieldset label="Usuário Desktop (Opcional)">
                        <UsuarioDesktopDropDown v-model="registro.USUARIO_DESKTOP_ID" :disabled="desabilitado" />
                        <small class="form-text text-muted">Deixe vazio para criar novo usuário automaticamente</small>
                    </b-form-fieldset>
                 </b-col>
                 <b-col sm="4">
                    <b-form-fieldset label="Vendedor">
                        <VendedorDropdown v-model="registro.VENDEDOR_ID" :disabled="desabilitado" />
                    </b-form-fieldset>
                 </b-col>
                 <b-col sm="4">
                    <b-form-fieldset label="Funcionário (Motorista)">
                        <FuncionarioDropdown v-model="registro.FUNCIONARIO_ID" :disabled="desabilitado" />
                        <small class="form-text text-muted">Vincule ao funcionário motorista para acesso ao Painel Motorista</small>
                    </b-form-fieldset>
                 </b-col>
              </b-row>
              
              <b-row class="mt-2">
                 <b-col sm="6">
                    <b-form-fieldset label="Tela Inicial Personalizada (Opcional)">
                        <MenuDropdown 
                          v-model="registro.TELA_INICIAL" 
                          :disabled="desabilitado"
                          placeholder="Usar padrão do grupo ou do sistema"
                        />
                        <small class="form-text text-muted">
                          <i class="fa fa-info-circle"></i> 
                          Define qual tela será exibida após o login. Se não configurado, usa o padrão do grupo de acesso.
                        </small>
                    </b-form-fieldset>
                 </b-col>
              </b-row>
              
              <b-row class="mt-3">
                 <b-col sm="6">
                    <b-form-group label="Foto (PNG)" label-for="file-foto">
                        <b-form-file
                          id="file-foto"
                          v-model="fileFoto"
                          :state="Boolean(fileFoto)"
                          placeholder="Escolha uma imagem PNG ou solte aqui..."
                          drop-placeholder="Solte a imagem aqui..."
                          accept=".png"
                          @change="onFileChange"
                        ></b-form-file>
                        <div class="mt-3" v-if="previewImage || registro.FOTO">
                            <b-img :src="previewImage || registro.FOTO" fluid thumbnail style="max-height: 200px"></b-img>
                            <b-button v-if="previewImage" size="sm" variant="danger" class="ml-2" @click="limparFoto">Remover Seleção</b-button>
                        </div>
                    </b-form-group>
                 </b-col>
              </b-row>
                
            </b-card>
           
          </div>
        </b-row>
        
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import GrupoAcessoDropDown from '@/views/componentes/dropdown/GrupoAcessoDropDown.vue'
import UsuarioDesktopDropDown from '@/views/componentes/dropdown/UsuarioDesktopDropDown.vue'
import VendedorDropdown from '@/views/componentes/dropdown/VendedorDropdown.vue'
import FuncionarioDropdown from '@/views/componentes/dropdown/FuncionarioDropdown.vue'
import MenuDropdown from '@/views/componentes/dropdown/MenuDropdown.vue'

export default {
  data () {
    return {
      perfilSelecionado: '',
      processando: false,
      desabilitado: true,
      registro: {}, // Initialize as object
      
      fileFoto: null,
      previewImage: null
    }
  },
  components: {
    GrupoAcessoDropDown,
    UsuarioDesktopDropDown,
    MenuDropdown,
    VendedorDropdown,
    FuncionarioDropdown
  },
  methods: {
      
    async post () {
      this.$store.commit('controle/setAguardando', true)
      this.processando = true
      try {
        if (this.avisos()) {
          await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', this.avisos() )
          return
        }
        
        const login = window.localStorage.getItem('login') || 'sistema'
        const usuarioPayload = { ...this.registro }
        usuarioPayload.NAME = this.registro.NOME_COMPLETO
        
        // Remove FOTO from JSON payload since we send it as a file/blob
        // to avoid sending huge string + file duplication
        delete usuarioPayload.FOTO 

        const formData = new FormData()
        formData.append('login', login)
        formData.append('usuario', JSON.stringify(usuarioPayload))

        // Handle Photo:
        // 1. If new file selected (this.fileFoto), append it.
        // 2. If no new file but existing photo (this.registro.FOTO), convert base64 to blob and append (to preserve it).
        // 3. Else, don't append (backend sets null).
        
        if (this.fileFoto) {
            formData.append('FOTO', this.fileFoto)
        } else if (this.registro.FOTO && this.registro.FOTO.startsWith('data:image')) {
            const blob = this.dataURItoBlob(this.registro.FOTO)
            formData.append('FOTO', blob, 'existing_photo.png')
        }

        const config = { headers: { 'Content-Type': 'multipart/form-data' } }

        if ((this.$route.params.id === undefined )) {
          // Creating
          await this.$http.post(`/api/protected/usuario/post`, formData, config)
          await this.$store.dispatch('usuario/GERAR_LISTA')
          this.$router.push(`/seguranca/usuario/index`)
        } else  {
          // Editing
          await this.$http.post(`/api/protected/usuario/edit`, formData, config)
          await this.$store.dispatch('usuario/GERAR_LISTA')
          this.$router.push(`/seguranca/usuario/index`)
        }
        Tools.exibirMensagem(this.$store, 'Sucesso', 'success', 'Usuário salvo com sucesso!' )
        
      } catch (err) {
        Tools.exibirMensagemErro(this.$store, 'Erro', 'error', err)
      } finally {
        this.processando = false
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        const byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to an ArrayBuffer
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], {type: mimeString});
    },
    
    limparRegistro () {
      this.registro = {
          ID: null,
          CPF: null,
          NOME_COMPLETO: null,
          EMAIL: null,
          SENHA: null,
          SENHA_CONFIRMA: null,
          USUARIO_DESKTOP_ID: null,
          VENDEDOR_ID: null,
          FUNCIONARIO_ID: null,
          GRUPO_ACESSO_ID: null,
          TELA_INICIAL: null,
          FOTO: null
      }
      this.fileFoto = null
      this.previewImage = null
    },
    
    async iniciarFormNovo () {
      this.limparRegistro()
      this.desabilitado = false
    },
    
    async iniciarFormEditar ( id ) {
      try {
        this.$store.commit('controle/setAguardando', true)
        // Assuming there is a getById endpoint or we mock it/search for it. 
        // The prompt only listed Search, Delete, Post, Edit. I might need to find the user in the store list or assume getById exists.
        // Usually `getById` exists if `edit` exists. I'll search for it similarly to Vendedor.
        // Vendedor uses `/api/protected/vendedor/getById/${id}`
        // I'll try `/api/protected/usuario/getById/${id}` or reuse the search if getById returns 404.
        // For now I'll assume standard pattern.
        
        // However, the prompt didn't explicitly list a getById endpoint. 
        // "Pesquisar na listagem da pagina de pesquisar POST /api/protected/usuario/pesquisar {nome:xxx, id:xxxx}"
        // If getById is missing, I can use the Search endpoint with ID.
        
        const { data } = await this.$http.get(`/api/protected/usuario/getById/${id}`)
        
        // Backend returns the object directly, not an array (based on user code)
        // But we can support both to be safe
        const usuarioData = Array.isArray(data) ? data[0] : data

        if (!usuarioData) {
             await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Usuário não encontrado!' )
             this.$router.replace('/seguranca/usuario/index') 
             return
        }

        this.registro = { ...usuarioData }

        // Adjust FOTO if it comes as raw base64 without prefix
        if (this.registro.FOTO && !this.registro.FOTO.startsWith('data:image')) {
            this.registro.FOTO = `data:image/png;base64,${this.registro.FOTO}`
        }

        this.desabilitado = false
        // Reset file input
        this.fileFoto = null
        this.previewImage = null 
        // If FOTO comes from backend, it should be in registro.FOTO (blob/base64)
        
      } catch(err) {
        throw err
      }
    },
    
    avisos() {
      if (!this.registro.CPF) return 'Preencha o Login/CPF'
      if (!this.registro.GRUPO_ACESSO_ID) return 'Selecione o Grupo de Acesso'
      
      // Validações para novo cadastro (sem ID)
      if (!this.registro.ID && !this.registro.USUARIO_DESKTOP_ID) {
        if (!this.registro.NOME_COMPLETO) return 'Preencha o Nome Completo'
        if (!this.registro.SENHA) return 'Preencha a Senha'
        if (!this.registro.SENHA_CONFIRMA) return 'Confirme a Senha'
        if (this.registro.SENHA !== this.registro.SENHA_CONFIRMA) {
          return 'As senhas não coincidem'
        }
        if (this.registro.SENHA.length < 4) {
          return 'A senha deve ter no mínimo 4 caracteres'
        }
      }
      
      return false
    },
    
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        if (file.type !== 'image/png') {
             Tools.exibirMensagem(this.$store, 'Erro', 'danger', 'Apenas imagens PNG são permitidas!' )
             this.fileFoto = null
             return
        }
        this.createBase64Image(file);
      }
    },
    
    createBase64Image(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewImage = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    
    limparFoto() {
        this.fileFoto = null
        this.previewImage = null
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
  },
  async created () {
    try {
      let id = this.$route.params.id
      if ( id ) {
        await this.iniciarFormEditar( id )
      } else {
        await this.iniciarFormNovo()
      }
    } catch(error) {
        await Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Erro ao carregar usuário!' )
        this.$router.replace('/seguranca/usuario/index')
        return
    }
    finally {
      this.$store.commit('controle/setAguardando', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/seguranca/usuario/UsuarioCadastro.vue